<div class="ey-nav-container" [ngClass]="{ 'ey-nav-sideCollapsed': sideExpanded === false, 'ey-nav-topCollapsed': topExpanded === false }">
  <div>
    <div class="ey-header-container">
      <a class="navbar-brand" [routerLink]="['/']">
        <img src="assets/images/EY Logo.png" alt="Logo" />
        <span class="ey-home-title">TP Benchmark</span>
      </a>
      <button
        type="button"
        class="btn btn-link ey-menu-slide-button"
        (click)="toggleSide()"
        ngbTooltip="{{ 'navigationMenu' | tpbTooltip }}"
        placement="right-top"
      >
        <i class="ey-collapse-icon material-icons">menu</i>
        <i class="ey-expand-icon material-icons">menu</i>
      </button>
      <button type="button" class="btn btn-link ey-menu-button" (click)="toggleTop()">
        <i class="material-icons">menu</i>
      </button>
    </div>
    <div class="ey-nav-items-container">
      <ul class="nav flex-column">
        <li [routerLinkActive]="['active']" [routerLinkActiveOptions]="{ exact: false }">
          <a [routerLink]="[linkDashboard]" class="nav-link" (click)="closeTop()">
            <i class="ey-menu-icon material-icons">dashboard</i>
            <span class="ey-menu-text">Dashboard</span>
          </a>
        </li>
        <li [routerLinkActive]="['active']" [routerLinkActiveOptions]="{ exact: false }">
          <a [routerLink]="[linkSearchStudies]" class="nav-link" (click)="closeTop()">
            <i class="ey-menu-icon material-icons">search</i>
            <span class="ey-menu-text">Search Studies</span>
          </a>
        </li>
        <li [routerLinkActive]="['active']" [routerLinkActiveOptions]="{ exact: false }">
          <a [routerLink]="[linkMyStudies]" class="nav-link" (click)="closeTop()">
            <i class="ey-menu-icon material-icons">card_travel</i>
            <span class="ey-menu-text">My Studies</span>
          </a>
        </li>

        <!-- Commented out until we implement these features
    <li [routerLinkActive]='["active"]' [routerLinkActiveOptions]='{ exact: false }'>
      <a [routerLink]='["/favorites"]' class="nav-link" (click)="closeTop()">
        <i class="ey-menu-icon material-icons">favorite_border</i>
        <span class="ey-menu-text">Favorites</span>
      </a>
    </li>
    <li [routerLinkActive]='["active"]' [routerLinkActiveOptions]='{ exact: false }'>
      <a [routerLink]='["/reports"]' class="nav-link" (click)="closeTop()">
        <i class="ey-menu-icon material-icons">equalizer</i>
        <span class="ey-menu-text">Reports</span>
      </a>
    </li>
    <li [routerLinkActive]='["active"]' [routerLinkActiveOptions]='{ exact: false }'>
      <a [routerLink]='["/notifications"]' class="nav-link" (click)="closeTop()">
        <i class="ey-menu-icon material-icons">notifications_none</i>
        <span class="ey-menu-text">Notifications</span>
      </a>
    </li>
  -->
        <li [routerLinkActive]="['active']" [routerLinkActiveOptions]="{ exact: false }">
          <a [routerLink]="['/admin']" class="nav-link" (click)="toggleTop()">
            <i class="ey-menu-icon material-icons">person_outline</i>
            <span class="ey-menu-text">Admin</span>
          </a>
        </li>
        <li [routerLinkActive]="['active']" [routerLinkActiveOptions]="{ exact: false }">
          <a [routerLink]="['/privacynotice']" class="nav-link" (click)="toggleTop()">
            <i class="ey-menu-icon material-icons">note</i>
            <span class="ey-menu-text">Privacy Notice</span>
          </a>
        </li>
        <li>
          <a #notificationAnchor href (click)="showNotificationsDialog(notificationAnchor)" class="nav-link">
            <span class="ey-menu-icon"><app-notification-indicator></app-notification-indicator></span>
            <span class="ey-menu-text">Notifications</span>
          </a>
        </li>
        <li class="ey-nav-logout">
          <!-- Automatically logged into app so only need this if we turned that off
    <a class="nav-link" *ngIf="loggedIn === false" (click)="logIn()">
      <i class="ey-menu-icon material-icons">person_outline</i>
      <span class="ey-menu-text">Login</span>
    </a>
  -->
          <a
            class="nav-link"
            *ngIf="loggedIn === true"
            (click)="logOut()"
            title="Logout User: {{ currentUser?.displayName }} - ({{ currentUser?.userPrincipalName }})"
          >
            <i class="ey-menu-icon material-icons">exit_to_app</i>
            <span class="ey-menu-text">Logout</span>
          </a>
        </li>
      </ul>
      <div
        style="font-size: 10px; color: #616161; padding-left: 1.5rem"
        *ngIf="this.currentUser !== undefined && this.sideExpanded && (this.apiBuildVersion$ | async) !== undefined"
      >
        <div *ngIf="this.sideExpanded">
          <span>{{ this.apiBuildVersion$ | async }}</span>
        </div>
      </div>
    </div>
  </div>
</div>
